module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 6.73L1.78.586 1.187 0 0 1.172l.593.587 6.204 6.126-6.156 6.23-.585.594 1.173 1.187.586-.593L8 9.042l6.186 6.262.586.593 1.173-1.187-.586-.593-6.157-6.23 6.204-6.128L16 1.17 14.813 0l-.593.586L8 6.73z\" fill=\"#999\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close.svg
// module id = 206
// module chunks = 0 1